"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var React = require("react");
var commonFunctions_1 = require("../../helpers/commonFunctions");
var Tree_1 = require("../../components/Tree");
var ExtraCoversTree = /** @class */ (function (_super) {
    __extends(ExtraCoversTree, _super);
    function ExtraCoversTree(props) {
        var _this = _super.call(this, props) || this;
        _this.renderExtraCovers = function () {
            var _a, _b, _c, _d, _e;
            var extraCovers = [];
            var personalPossessionCoverLimit = (_a = _this.props.interaction.annualHomeExtraCovers) === null || _a === void 0 ? void 0 : _a.personalPossessionCoverLimit;
            extraCovers.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Personal Belongings - ", (0, commonFunctions_1.getAmountToDisplay)(personalPossessionCoverLimit)] }) }, "Personal Belongings"));
            _this.renderExtraCover(extraCovers, "Enhanced buildings Accidental Damage", ((_b = _this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.buildingAccidentalDamage) ? _this.props.interaction.annualHomeFixedAddons.buildingAccidentalDamage : false);
            _this.renderExtraCover(extraCovers, "Enhanced contents Accidental Damage", ((_c = _this.props.interaction.annualHomeFixedAddons) === null || _c === void 0 ? void 0 : _c.contentsAccidentalDamage) ? _this.props.interaction.annualHomeFixedAddons.contentsAccidentalDamage : false);
            _this.renderExtraCover(extraCovers, "Home Legal Expenses", ((_d = _this.props.interaction.annualHomeFixedAddons) === null || _d === void 0 ? void 0 : _d.homeLegalExpenses) ? _this.props.interaction.annualHomeFixedAddons.homeLegalExpenses : false);
            _this.renderExtraCover(extraCovers, "Home Emergency", ((_e = _this.props.interaction.annualHomeFixedAddons) === null || _e === void 0 ? void 0 : _e.homeEmergency) ? _this.props.interaction.annualHomeFixedAddons.homeEmergency : false);
            return extraCovers.length > 0 ? extraCovers : null;
        };
        return _this;
    }
    ExtraCoversTree.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Extra covers", children: this.renderExtraCovers() }));
    };
    ExtraCoversTree.prototype.renderExtraCover = function (extraCoversArray, coverName, isIncluded) {
        extraCoversArray.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [coverName, " - ", isIncluded ? "Included" : "Not included"] }) }, coverName));
    };
    ExtraCoversTree = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], ExtraCoversTree);
    return ExtraCoversTree;
}(React.Component));
exports.default = ExtraCoversTree;
//# sourceMappingURL=ExtraCoversTree.js.map